<!--
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Liwg
 * @date  2025/05/06 18:04
 * @des
-->
<template>
  <el-container class="container">
    <img class="home-bg" src="@/assets/images/padcontrol_home_bg.png">
    <pad-pc-offical-view v-if="!isMobile" @downloadAndroidApp="downloadAndroidApp" @downloadIOSApp="downloadIOSApp"></pad-pc-offical-view>
    <pad-mobile-offical-view v-else @downloadAndroidApp="downloadAndroidApp" @downloadIOSApp="downloadIOSApp"></pad-mobile-offical-view>
    <span class="bottom-copyright" v-if="!isMobile">{{ $t('padcontrol.copyright') }}</span>
  </el-container>
</template>

<script>
import {
  Container
} from 'element-ui'

import PadPcOfficalView from './PadPcOfficalView.vue'
import PadMobileOfficalView from './PadMobileOfficalView.vue'

export default {
  name: 'Home',
  components: {
    PadMobileOfficalView,
    PadPcOfficalView,
    'ElContainer': Container
  },
  data () {
    return {}
  },
  mounted () {
    setTimeout(() => {
      document.title = '小雨优学智能'
    }, 10) // 延迟执行，确保不会被init.js中的i18nTitleDefault覆盖
    this.changeFavicon('/res/static/images/logo_padcontrol.ico')
  },
  methods: {
    changeFavicon (newIconUrl) {
      let favicon = document.getElementById('favicon')
      favicon.href = newIconUrl
    },
    onPageResize (width, height, isMobile) {
      this.$log(`平板官网 ${width} ${height} ${isMobile}`)
    },
    downloadAndroidApp () {
      // console.log('下载Android')
      window.open("/v1/version/download?app=k12_pad_control&platform=android","_blank")
    },
    downloadIOSApp () {
      // console.log('下载iOS')
      window.open("https://itunes.apple.com/us/app/6744909651","_blank")
    }
  },
}
</script>

<style scoped>

.container {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.home-bg {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
}

.bottom-copyright {
  text-align: center;
  color: #333333;
  font-size: 14px;
  z-index: 1;
  position: relative;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/pad-control/index.vue